<template>
  <responsive-modal v-model="visible">
    <div
      class="d-flex flex-column text-center justify-content-center align-items-center p-6 modal-form"
    >
      <div class="container-icon mb-9 mt-5">
        <i v-if="!!icon" :class="icon"></i>
        <img v-else :src="image" class="image-icon" />
        <img src="@/assets/images/btn-stars.png" class="image-stars" />
      </div>

      <span class="font-weight-bold">{{ title }}</span>
      <small class="mb-5 text-muted">
        {{ description }}
      </small>

      <div
        v-for="(item, index) in form"
        :key="index"
        class="d-flex flex-column w-100"
      >
        <form-group
          v-model="item.value"
          class="text-left"
          :id="item.id"
          :label="label(item)"
          :type="item.type"
          :placeholder="item.placeholder"
          :errors="inputsErrors[index].errors"
        />
      </div>
      <div class="d-flex justify-content-between mt-9">
        <button
          class="btn btn-fixed-size btn-outline-secondary mr-2"
          @click="$emit('cancel')"
        >
          Cancelar
        </button>
        <button
          class="btn btn-fixed-size"
          :class="true ? 'btn-primary ' : 'btn-secondary'"
          @click="$emit('action')"
        >
          <loading :show="loading">
            {{ textBtnAction }}
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>

<script>
// padrão do form ==> { value: null, label: "", placeholder: "", id: "", type: "", isTextarea: false,}
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Title"
    },
    description: {
      type: String,
      default: "description"
    },
    textBtnAction: {
      type: String,
      default: "Concluir"
    },
    form: {
      type: Array,
      default: () => []
    },
    inputsErrors: {
      type: Array,
      default: () => []
    },
    image: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  },
  methods: {
    label(item) {
      return item.label ? item.label : item.value ? item.placeholder : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-form {
  .container-icon {
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 24px;
    background: linear-gradient(
      148.5deg,
      rgba($color: #ee6469, $alpha: 0.2) -19.31%,
      rgba($color: #5576ec, $alpha: 0.2) 100%
    );
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      color: #5576ec;
      font-size: 38px;
    }

    .image-stars {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 25%;
    }
  }
}
</style>
